<template>
    <div>
        <p class="sub-heding-text text-zinc-50">Total sensors</p>
        <div class="number-text flex justify-end gap-2 items-center">
            <p>428</p>
            <div class="flex flex-row items-center text-success font-semibold gap-1 status-text">
                <up-arrow-svg />
                5%
            </div>
        </div>
    </div>

    <div class="flex flex-col gap-2">
        <div class="progress-bar">
            <div class="flex justify-between mb-2">
                <p class="sub-heding-text text-zinc-400 ">Error Sensors</p>
                <p class="sub-heding-text text-zinc-50">42 (3%)</p>
            </div>
            <div class="progress-line">
                <div class="bg-error-400 h-1.5 rounded-full" style="width: 75%"></div>
            </div>
        </div>
        <div class="progress-bar">
            <div class="flex justify-between mb-2">
                <p class="sub-heding-text text-zinc-400 ">Warning Sensors</p>
                <p class="sub-heding-text text-zinc-50">18 (4%)</p>
            </div>
            <div class="progress-line">
                <div class="bg-warning-600 h-1.5 rounded-full" style="width: 50%"></div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import UpArrowSvg from '~/components/main/soc/common_svg/UpArrowSvg.vue';
</script>
